import { Component } from '@angular/core';
import { ORCIDEmailEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Emails') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidemail-form',
    templateUrl: './orcidemail.form.component.html'
})
export class ORCIDEmailFormComponent extends BaseFormComponent {
    public record!: ORCIDEmailEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

